module.exports = __webpack_public_path__ + "static/media/carril.4bd23bf1.png";